// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorCoveragePharmacyCoveragePharmacyCoverageRequest {
    static getAttributeTypeMap() {
        return PayorCoveragePharmacyCoveragePharmacyCoverageRequest.attributeTypeMap;
    }
}
PayorCoveragePharmacyCoveragePharmacyCoverageRequest.discriminator = undefined;
PayorCoveragePharmacyCoveragePharmacyCoverageRequest.additionalProperties = false;
PayorCoveragePharmacyCoveragePharmacyCoverageRequest.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
];
//# sourceMappingURL=payorCoveragePharmacyCoveragePharmacyCoverageRequest.js.map